<template>
  <div class="my-wallet-page">
    <div class="wallet-header">
      <div class="nav-top">
        <i class="el-icon-arrow-left" @click="$router.back()"></i>
        <span class="title">我的钱包</span>
        <div class="placeholder"></div>
      </div>
      <div class="accumulated-box">
        <div class="acc-item">
          <p class="acc-label">今年累计已到账 (元)</p>
          <p class="acc-value">{{ formatMoney(yearData.yearReceived) }}</p>
        </div>
        <div class="acc-item">
          <p class="acc-label">今年累计未到账 (元)</p>
          <p class="acc-value">{{ formatMoney(yearData.yearPending) }}</p>
        </div>
      </div>
    </div>

    <div class="settlement-section">
      <div class="date-filter">
        <span class="label">结算日期</span>
        <div class="date-trigger" @click="showDatePicker = true">
          {{ dateRange }} <i class="el-icon-caret-bottom"></i>
        </div>
      </div>

      <div class="stats-cards">
        <div class="stat-card" :class="{active: currentQueryType === 'shouldReceive'}" @click="queryByType('shouldReceive')">
          <p class="s-label">应到账金额 (元)</p>
          <p class="s-value">{{ formatMoney(statsData.shouldReceive) }}</p>
        </div>
        <div class="stat-card" :class="{active: currentQueryType === 'received'}" @click="queryByType('received')">
          <p class="s-label"><span class="dot green"></span>已到账</p>
          <p class="s-value">{{ formatMoney(statsData.received) }}</p>
        </div>
        <div class="stat-card" :class="{active: currentQueryType === 'pending'}" @click="queryByType('pending')">
          <p class="s-label"><span class="dot red"></span>未到账</p>
          <p class="s-value">{{ formatMoney(statsData.pending) }}</p>
        </div>
      </div>
    </div>

    <div class="bill-list" v-if="billList.length > 0">
      <div class="bill-card" v-for="(bill, index) in billList" :key="index">
        <div class="bill-row main-row">
          <div class="left">
            <span class="b-label">账单金额 (元)</span>
            <span class="status-tag" :class="bill.statusClass">{{ bill.statusText }}</span>
          </div>
          <div class="right">
            <span class="b-value">{{ formatMoney(bill.amount) }}</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="bill-row info-row">
          <span class="b-label">到账时间</span>
          <span class="b-info">{{ bill.arriveTime || '-' }}</span>
        </div>
        <div class="bill-row info-row">
          <span class="b-label">结算日期</span>
          <span class="b-info">{{ bill.settleDate }}</span>
        </div>
      </div>
    </div>

    <div class="empty-state" v-else>
      <i class="el-icon-wallet" style="font-size: 60px; color: #ccc;"></i>
      <p>暂无账单记录</p>
    </div>

    <el-dialog title="选择日期" :visible.sync="showDatePicker" width="90%">
      <div class="date-options">
        <div class="date-option" :class="{active: queryType === 1}" @click="queryType = 1; loadBillList()">按月查询</div>
        <div class="date-option" :class="{active: queryType === 2}" @click="queryType = 2; loadBillList()">按年查询</div>
      </div>
      <el-date-picker
        v-if="queryType === 1"
        v-model="selectedMonth"
        type="month"
        placeholder="选择月份"
        value-format="yyyy-MM"
        @change="onDateChange"
      />
      <el-date-picker
        v-else
        v-model="selectedYear"
        type="year"
        placeholder="选择年份"
        value-format="yyyy"
        @change="onDateChange"
      />
      <div slot="footer">
        <el-button @click="showDatePicker = false">取消</el-button>
        <el-button type="primary" @click="confirmDate">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getMyData, getOperatorReconciliationList } from "@/api/newApi";

export default {
  name: 'MyWallet',
  data() {
    return {
      showDatePicker: false,
      queryType: 1,
      currentQueryType: '',  // 当前查询类型: '', 'shouldReceive', 'received', 'pending'
      selectedMonth: '',
      selectedYear: '',
      dateRange: '请选择日期',
      yearData: {
        yearReceived: 0,
        yearPending: 0
      },
      statsData: {
        shouldReceive: 0,
        received: 0,
        pending: 0
      },
      billList: []
    };
  },
  mounted() {
    const currentYear = new Date().getFullYear();
    const currentMonth = String(new Date().getMonth() + 1).padStart(2, '0');
    this.selectedYear = String(currentYear);
    this.selectedMonth = `${currentYear}-${currentMonth}`;
    this.dateRange = this.selectedMonth;
    this.getWalletData();
    this.getYearData();
    this.loadBillList();
  },
  methods: {
    async getWalletData() {
      try {
        const res = await getMyData({});
        console.log('钱包数据返回:', res);
        if (res.data) {
          // res.data.amount 是账户余额
        }
      } catch (err) {
        console.log('获取钱包数据失败', err);
      }
    },
    async getYearData() {
      try {
        const currentYear = new Date().getFullYear();
        console.log('查询年度数据, 年份:', currentYear);
        const res = await getOperatorReconciliationList({
          queryType: 2,
          startTime: `${currentYear}`,
          endTime: `${currentYear}`,
          pageNo: 1,
          pageSize: 100
        });
        console.log('年度对账数据返回:', res);
        console.log('res.data:', res.data);
        console.log('res.data.records:', res.data ? res.data.records : 'no data');
        if (res.data && res.data.records && res.data.records.length > 0) {
          let yearReceived = 0;
          let yearPending = 0;
          res.data.records.forEach(item => {
            console.log('对账记录项:', item);
            const operatorMoney = parseFloat(item.operatorMoney) || 0;
            const totalMoney = parseFloat(item.totalMoney) || 0;
            yearReceived += operatorMoney;
            yearPending += (totalMoney - operatorMoney);
          });
          this.yearData.yearReceived = yearReceived;
          this.yearData.yearPending = yearPending;
          console.log('计算后yearData:', this.yearData);
        } else {
          console.log('没有年度对账数据，尝试查询所有年份');
          // 尝试查询所有年份的数据
          const allRes = await getOperatorReconciliationList({
            queryType: 2,
            pageNo: 1,
            pageSize: 100
          });
          console.log('所有年度数据返回:', allRes);
          if (allRes.data && allRes.data.records && allRes.data.records.length > 0) {
            let yearReceived = 0;
            let yearPending = 0;
            allRes.data.records.forEach(item => {
              const operatorMoney = parseFloat(item.operatorMoney) || 0;
              const totalMoney = parseFloat(item.totalMoney) || 0;
              yearReceived += operatorMoney;
              yearPending += (totalMoney - operatorMoney);
            });
            this.yearData.yearReceived = yearReceived;
            this.yearData.yearPending = yearPending;
          }
        }
      } catch (err) {
        console.log('获取年度数据失败', err);
      }
    },
    queryByType(type) {
      this.currentQueryType = type;
      this.loadBillList();
    },
    async loadBillList() {
      try {
        let startTime = '', endTime = '';
        if (this.queryType === 1 && this.selectedMonth) {
          startTime = `${this.selectedMonth}-01`;
          const [y, m] = this.selectedMonth.split('-');
          endTime = `${y}-${m}-${new Date(y, m, 0).getDate()}`;
          this.dateRange = `${this.selectedMonth}`;
        } else if (this.queryType === 2 && this.selectedYear) {
          startTime = `${this.selectedYear}`;
          endTime = `${this.selectedYear}`;
          this.dateRange = `${this.selectedYear}`;
        }

        const res = await getOperatorReconciliationList({
          queryType: this.queryType,
          startTime: startTime,
          endTime: endTime,
          pageNo: 1,
          pageSize: 100
        });
        console.log('对账记录返回:', res);
        if (res.data && res.data.records) {
          let shouldReceive = 0;
          let received = 0;
          let pending = 0;

          this.billList = res.data.records.map(item => {
            const operatorMoney = parseFloat(item.operatorMoney) || 0;
            const totalMoney = parseFloat(item.totalMoney) || 0;
            const platMoney = parseFloat(item.platMoney) || 0;
            shouldReceive += totalMoney;
            received += operatorMoney;
            pending += (totalMoney - operatorMoney);

            let statusText = '已到账';
            let statusClass = 'received';
            let amountToShow = operatorMoney;

            if (this.currentQueryType === 'shouldReceive') {
              amountToShow = totalMoney;
              statusText = '应到账';
              statusClass = 'pending';
            } else if (this.currentQueryType === 'received') {
              amountToShow = operatorMoney;
              statusText = '已到账';
              statusClass = 'received';
            } else if (this.currentQueryType === 'pending') {
              amountToShow = totalMoney - operatorMoney;
              statusText = '未到账';
              statusClass = 'pending';
            }

            return {
              amount: amountToShow,
              settleDate: this.queryType === 1 ? item.month : item.year,
              arriveTime: item.updateTime || '-',
              statusText: statusText,
              statusClass: statusClass,
              totalMoney: item.totalMoney,
              platMoney: item.platMoney
            };
          });

          this.statsData.shouldReceive = shouldReceive;
          this.statsData.received = received;
          this.statsData.pending = pending;
        } else {
          this.billList = [];
        }
      } catch (err) {
        console.log('获取对账记录失败', err);
        this.billList = [];
      }
    },
    onDateChange() {
      // 日期选择变化
    },
    confirmDate() {
      this.showDatePicker = false;
      if (this.selectedMonth || this.selectedYear) {
        this.loadBillList();
      }
    },
    formatMoney(val) {
      if (!val && val !== 0) return '0.00';
      return Number(val).toFixed(2);
    }
  }
};
</script>

<style lang="scss" scoped>
.my-wallet-page {
  background-color: #F6F8FA;
  min-height: 100vh;
  padding-bottom: 30px;
}

.wallet-header {
  background-color: #00BFA5;
  color: #FFF;
  padding: 15px 16px 30px;
  .nav-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
    i { font-size: 20px; }
    .title { font-size: 18px; font-weight: 500; }
    .placeholder { width: 20px; }
  }
  .accumulated-box {
    display: flex;
    .acc-item {
      flex: 1;
      .acc-label { font-size: 13px; opacity: 0.8; margin-bottom: 8px; }
      .acc-value { font-size: 24px; font-weight: bold; }
    }
  }
}

.settlement-section {
  margin: -15px 16px 15px;
  background: #FFF;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.03);

  .date-filter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #F0F0F0;
    padding-bottom: 12px;
    margin-bottom: 15px;
    .label { font-size: 14px; color: #666; }
    .date-trigger {
      font-size: 14px;
      color: #333;
      font-weight: 500;
      cursor: pointer;
      i { margin-left: 4px; color: #BBB; }
    }
  }

  .stats-cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    .stat-card {
      background: #F8FAFB;
      border-radius: 8px;
      padding: 10px;
      text-align: center;
      cursor: pointer;
      transition: all 0.3s;
      &.active { background: #00BFA5; color: #FFF; .s-label { color: rgba(255,255,255,0.8); } .s-value { color: #FFF; } }
      .s-label {
        font-size: 11px;
        color: #999;
        margin-bottom: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        .dot { width: 6px; height: 6px; border-radius: 50%; margin-right: 4px; }
        .dot.green { background: #52C41A; }
        .dot.red { background: #FF4D4F; }
      }
      .s-value { font-size: 15px; font-weight: bold; color: #333; }
    }
  }
}

.bill-list {
  padding: 0 16px;
  .bill-card {
    background: #FFF;
    border-radius: 12px;
    margin-bottom: 12px;
    padding: 16px;
    .bill-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      &:last-child { margin-bottom: 0; }

      &.main-row {
        margin-bottom: 15px;
        .left {
          display: flex;
          align-items: center;
          .status-tag {
            font-size: 11px;
            padding: 2px 6px;
            border-radius: 10px;
            margin-left: 8px;
            &.received { color: #52C41A; background: #E8F9ED; }
            &.pending { color: #FF9500; background: #FFF7E6; }
          }
        }
        .right {
          display: flex;
          align-items: center;
          .b-value { font-size: 20px; font-weight: bold; margin-right: 4px; }
          i { color: #CCC; font-size: 14px; }
        }
      }

      .b-label { font-size: 14px; color: #999; }
      .b-info { font-size: 14px; color: #333; }
    }
  }
}

.empty-state {
  text-align: center;
  padding-top: 60px;
  p { color: #999; font-size: 14px; margin-top: 12px; }
}

.date-options {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  .date-option {
    flex: 1;
    text-align: center;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
    &.active {
      background: #00BFA5;
      color: #fff;
      border-color: #00BFA5;
    }
  }
}
</style>